import { useState } from 'react';
import CollapsableHeader from '../../components/CollapsableHeader/CollapsableHeader';
import CheckboxAndData from '../../components/CheckboxAndData/CheckboxAndData';
import styles from './ActivitiesSettingsPage.module.css';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import BackHeader from '../../components/BackHeader/BackHeader';
import SearchBar from '../../components/SearchBar/SearchBar';
import IconAndName from '../../components/IconAndName/IconAndName';
import ActivityListItem from '../../components/ActivityListItem/ActivityListItem';
import ActivitySettings from '../../components/ActivitySettings/ActivitySettings';

import photoImage from './../../assets/images/Dailyactivityphoto.png';
import announcementsImage from './../../assets/images/announcements.png';
import musicPlayImage from './../../assets/images/musicPlay.png';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';

export default function ActivitiesSettingsPage() {
  const dispatch = useDispatch();
  const [checkboxes, setCheckboxes] = useState([
    {
      label: 'While posting show only checked in students',
      isChecked: false,
    },
    {
      label: 'While posting show only checked in students',
      isChecked: false,
    },
    {
      label: 'Disable video download for all activities',
      isChecked: false,
    },
  ]);

  const activityList = [
    {
      id: 'photo',
      label: 'Photo',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
      color: 'var(--Primary_Color)',
    },
    {
      id: 'video',
      label: 'Video',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
      color: 'var(--Error_Color)',
    },
    {
      id: 'announcements',
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
      color: 'var(--Success_Color)',
    },
  ];

  const [selectedActivityId, setSelectedActivityId] = useState('photo');
  const selectedActivity = activityList.find(
    (item) => item.id === selectedActivityId
  );

  const handleCheckboxChange = (index) => {
    const updated = [...checkboxes];
    updated[index].isChecked = !updated[index].isChecked;
    setCheckboxes(updated);
  };

  return (
    <div className={styles.ActivitiesSettingsPage}>
      <div className={styles.BackHeaderContainer}>
        <BackHeader label="Activity Settings" iconSize={18} />
      </div>

      <CollapsableHeader heading="General Settings">
        <div className={styles.collapsableContent}>
          {/* Left section - checkboxes */}
          <div className={styles.leftColumn}>
            {checkboxes.map((item, index) => (
              <CheckboxAndData
                key={index}
                label={item.label}
                checked={item.isChecked}
                checkboxSize={14}
                labelColor="var(--Black_Color)"
                onChange={() => handleCheckboxChange(index)}
              />
            ))}
          </div>

          {/* Right section - input shown only with second checkbox */}
          <div className={styles.rightColumn}>
            <HeadingAndData
              label={'Addition Email for CC in Announcement Mails '}
              placeholder={'Paste any related URL'}
            />
          </div>
        </div>
      </CollapsableHeader>

      <CollapsableHeader heading="Other Settings">
        <div className={styles.OtherSettingsTopSection}>
          <div style={{ width: '400px' }}>
            <SearchBar />
          </div>
          <IconAndName
            title="Create Activity"
            onClick={() => {
              dispatch(openModal('createActivity'));
            }}
          />
        </div>

        <div className={styles.OtherSettingsBottomSection}>
          <div className={styles.OtherSettingsBottomLeft}>
            {activityList.map((item) => (
              <ActivityListItem
                key={item.id}
                label={item.label}
                icon={item.icon}
                color={item.color}
                isActive={item.id === selectedActivityId}
                onClick={() => setSelectedActivityId(item.id)}
              />
            ))}
          </div>

          <div className={styles.OtherSettingsBottomRight}>
            <ActivitySettings activity={selectedActivity} />
          </div>
        </div>
      </CollapsableHeader>
    </div>
  );
}
